import { NavMarker } from 'react-rhumb';
import LearningPageMainSection from '../containers/TrackPage/LearningPageMainSection';
import { ShortContentDetails, ShortContentHeader, ShortContentInstructors, ShortContentPlaylistNavigation, ShortContentVideo, useShortFromPropsOrParams } from '../features/shortContent';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import ApiError from '../components/Errors/ApiError';
import { LearningContentPageLayout } from '../features/learningContent';
import UIFlex from 'UIComponents/layout/UIFlex';
import styled, { theme } from 'academy-common-lib/utils/Styling';
import { useEffect } from 'react';
import { SCREENS } from '../constants/Tracking';
import { css, mediaQuery } from 'academy-common-lib/utils/Styling';
import { RecommendationsForLearningContent } from '../features/recommendations';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HasGate } from '../features/accounts';
import { NamedRoute } from '../features/routing';
import { PAGE_NAMES, SHORT_CONTENT_URL_FRAGMENT } from '../constants/Navigation';
import { NextPlaylistContentOverview, PlaylistComplete, PlaylistIncompleteItems } from '../features/playlistContent';
import UsageTracker from '../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InstructorsSection = styled.div.withConfig({
  displayName: "ShortContent__InstructorsSection",
  componentId: "sc-14crk0x-0"
})(["background-color:", ";.instructors-tile-section{padding-left:0;padding-right:0;}"], theme.colors.GYPSUM);
const ShortSection = styled.div.withConfig({
  displayName: "ShortContent__ShortSection",
  componentId: "sc-14crk0x-1"
})(["", ""], mediaQuery('tablet', css(["padding-left:16px;padding-right:16px;"])));
const ShortContentBody = ({
  shortId,
  language
}) => {
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "SHORT_CONTENT_LOADED",
    children: /*#__PURE__*/_jsxs(UIFlex, {
      align: "stretch",
      direction: "column",
      gap: 36,
      children: [/*#__PURE__*/_jsx(LearningPageMainSection, {
        children: /*#__PURE__*/_jsx(ShortContentVideo, {})
      }), /*#__PURE__*/_jsx(LearningPageMainSection, {
        children: /*#__PURE__*/_jsx(ShortSection, {
          children: /*#__PURE__*/_jsx(ShortContentDetails, {})
        })
      }), /*#__PURE__*/_jsx(InstructorsSection, {
        children: /*#__PURE__*/_jsx(LearningPageMainSection, {
          children: /*#__PURE__*/_jsx(ShortSection, {
            children: /*#__PURE__*/_jsx(ShortContentInstructors, {})
          })
        })
      }), /*#__PURE__*/_jsx(LearningPageMainSection, {
        children: /*#__PURE__*/_jsx(RecommendationsForLearningContent, {
          appearsIn: "short-content-recommendations",
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.shortContent.recommendationsDescription"
          }),
          displayFullCardsOnMobile: true,
          errorMarker: "RECOMMENDATIONS_FOR_ENTITY_API_ERROR",
          id: shortId,
          language: language,
          navMarker: "RECOMMENDATIONS_FOR_ENTITY_LOADED",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.shortContent.recommendationsTitle"
          }),
          type: "SHORT_FORM_CONTENT"
        })
      })]
    })
  });
};
export const ShortPlaylistCompletionView = ({
  playlistNavigation,
  shortId,
  language
}) => {
  switch (playlistNavigation) {
    case 'next-in-playlist':
      return /*#__PURE__*/_jsx(NextPlaylistContentOverview, {
        language: language,
        shortId: shortId
      });
    case 'playlist-incomplete':
      return /*#__PURE__*/_jsx(PlaylistIncompleteItems, {});
    default:
      return /*#__PURE__*/_jsx(PlaylistComplete, {});
  }
};
export const ShortContent = () => {
  const {
    shortError,
    shortLoading,
    shortId,
    language,
    playlistId,
    playlistNavigation
  } = useShortFromPropsOrParams();
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: SCREENS.SHORT,
      contentId: shortId
    });
  }, [shortId]);
  if (!shortId || !language) return null;
  if (shortLoading) return /*#__PURE__*/_jsx(UILoadingSpinner, {
    grow: true,
    minHeight: 200
  });
  if (shortError) return /*#__PURE__*/_jsx(ApiError, {
    error: shortError,
    marker404: "SHORT_CONTENT_API_404",
    markerDefault: "SHORT_CONTENT_API_ERROR"
  });
  return /*#__PURE__*/_jsx(LearningContentPageLayout, {
    header: /*#__PURE__*/_jsx(ShortContentHeader, {}),
    navigation: playlistId && /*#__PURE__*/_jsx(ShortContentPlaylistNavigation, {}),
    children: playlistNavigation ? /*#__PURE__*/_jsx(ShortPlaylistCompletionView, {
      language: language,
      playlistNavigation: playlistNavigation,
      shortId: shortId
    }) : /*#__PURE__*/_jsx(ShortContentBody, {
      language: language,
      shortId: shortId
    })
  });
};
export const ShortContentRoute = () => {
  return /*#__PURE__*/_jsx(HasGate, {
    gate: "Academy:ShortFormContent",
    children: /*#__PURE__*/_jsx(NamedRoute, {
      component: ShortContent,
      exact: true,
      name: PAGE_NAMES.SHORT_CONTENT,
      path: SHORT_CONTENT_URL_FRAGMENT
    })
  });
};
export default ShortContentRoute;